import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=470be66e&scoped=true"
import script from "./device-info.vue?vue&type=script&lang=js"
export * from "./device-info.vue?vue&type=script&lang=js"
import style0 from "./device-info.vue?vue&type=style&index=0&id=470be66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470be66e",
  null
  
)

export default component.exports